import { isOnline, error as errorSignal } from '../store/state';
import { MessageList } from './MessageList';
import { MessageComposer } from './MessageComposer';
import type { WidgetConfig } from '../types';
import type { WidgetApiClient } from '../api/client';

interface ChatPanelProps {
  config: WidgetConfig;
  apiClient: WidgetApiClient | null;
  isOpen: boolean;
}

export function ChatPanel({ config, apiClient, isOpen }: ChatPanelProps) {
  const theme = config.theme || {};
  const title = theme.headerTitle || 'Support';
  const subtitle = theme.headerSubtitle || "We're here to help";

  return (
    <div class={`easyhelp-panel ${isOpen ? 'is-open' : ''}`}>
      {/* Header */}
      <div class="easyhelp-header">
        <div class="easyhelp-header-title">{title}</div>
        <div class="easyhelp-header-subtitle">{subtitle}</div>

        {/* Connection status */}
        <div class="easyhelp-header-status">
          <span class={`easyhelp-status-dot ${isOnline.value ? '' : 'offline'}`} />
          <span>{isOnline.value ? 'Online' : 'Offline'}</span>
        </div>
      </div>

      {/* Offline Banner */}
      {!isOnline.value && (
        <div class="easyhelp-offline-banner">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          <span>You're offline. Messages will be sent when you reconnect.</span>
        </div>
      )}

      {/* Error Banner */}
      {errorSignal.value && isOnline.value && (
        <div class="easyhelp-error-banner">
          {errorSignal.value}
        </div>
      )}

      {/* Messages */}
      <MessageList
        apiClient={apiClient}
        isActive={isOpen}
      />

      {/* Composer */}
      <MessageComposer
        apiClient={apiClient}
        disabled={!isOnline.value}
      />
    </div>
  );
}
